export const spliceTag = tag => {
  return (
    tag
      .substring(1)
      .charAt(0)
      .toUpperCase() + tag.substring(1).slice(1)
  );
};

export const originTag = tag => {
  return "#" + tag.charAt(0).toLowerCase() + tag.slice(1);
};

const tagOperations = { spliceTag, originTag };
export default tagOperations;
